import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  advisees: [],
  total: 0,
  page: 0,
  count: 20,
  isNamedQueriesEnabled: false
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/adviseeTracker/vuex/index.js